export default "__VITE_ASSET__C0hJ6itz__"